// Synthesized audio: footsteps + ambient drone via Web Audio API.
// No assets — everything is generated. Footsteps are filtered noise pops;
// ambient is a slow detuned pad.

export class GameAudio {
  constructor() {
    this.ctx = null;
    this.master = null;
    this.ambientStarted = false;
  }

  _ensure() {
    if (this.ctx) return;
    const Ctx = window.AudioContext || window.webkitAudioContext;
    this.ctx = new Ctx();
    this.master = this.ctx.createGain();
    this.master.gain.value = 0.5;
    this.master.connect(this.ctx.destination);
  }

  resume() {
    this._ensure();
    if (this.ctx.state === 'suspended') this.ctx.resume();
  }

  footstep({ crouched = false, sprinting = false } = {}) {
    this._ensure();
    const ctx = this.ctx;
    const now = ctx.currentTime;
    const buf = ctx.createBuffer(1, ctx.sampleRate * 0.18, ctx.sampleRate);
    const data = buf.getChannelData(0);
    for (let i = 0; i < data.length; i++) {
      const t = i / data.length;
      data[i] = (Math.random() * 2 - 1) * Math.pow(1 - t, 4);
    }
    const src = ctx.createBufferSource();
    src.buffer = buf;
    const filter = ctx.createBiquadFilter();
    filter.type = 'lowpass';
    filter.frequency.value = crouched ? 350 : sprinting ? 1100 : 700;
    const g = ctx.createGain();
    g.gain.value = crouched ? 0.18 : sprinting ? 0.55 : 0.35;
    src.connect(filter); filter.connect(g); g.connect(this.master);
    src.start(now);
  }

  startAmbient() {
    this._ensure();
    if (this.ambientStarted) return;
    this.ambientStarted = true;
    const ctx = this.ctx;
    const out = ctx.createGain();
    out.gain.value = 0.08;
    out.connect(this.master);
    // Slow detuned sines, occasionally reshape with LFO
    [110, 138.6, 220].forEach((f, i) => {
      const o = ctx.createOscillator();
      o.type = 'sine';
      o.frequency.value = f;
      const g = ctx.createGain();
      g.gain.value = 0.5;
      const lfo = ctx.createOscillator();
      lfo.frequency.value = 0.05 + i * 0.02;
      const lfoGain = ctx.createGain();
      lfoGain.gain.value = 0.3;
      lfo.connect(lfoGain); lfoGain.connect(g.gain);
      o.connect(g); g.connect(out);
      o.start(); lfo.start();
    });
    // Tape-hiss noise floor
    const buf = ctx.createBuffer(1, ctx.sampleRate * 2, ctx.sampleRate);
    const d = buf.getChannelData(0);
    for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * 0.015;
    const noise = ctx.createBufferSource();
    noise.buffer = buf; noise.loop = true;
    const nFilter = ctx.createBiquadFilter();
    nFilter.type = 'highpass'; nFilter.frequency.value = 4000;
    const nG = ctx.createGain(); nG.gain.value = 0.5;
    noise.connect(nFilter); nFilter.connect(nG); nG.connect(out);
    noise.start();
  }

  caught() {
    this._ensure();
    const ctx = this.ctx, now = ctx.currentTime;
    const o = ctx.createOscillator();
    o.type = 'sawtooth';
    o.frequency.setValueAtTime(440, now);
    o.frequency.exponentialRampToValueAtTime(80, now + 0.6);
    const g = ctx.createGain();
    g.gain.setValueAtTime(0.4, now);
    g.gain.exponentialRampToValueAtTime(0.001, now + 0.7);
    o.connect(g); g.connect(this.master);
    o.start(now); o.stop(now + 0.7);
  }
}
